export const FOOD_JOURNAL_GET_JOURNALS_BEGIN = 'FOOD_JOURNAL_GET_JOURNALS_BEGIN';
export const FOOD_JOURNAL_GET_JOURNALS_SUCCESS = 'FOOD_JOURNAL_GET_JOURNALS_SUCCESS';
export const FOOD_JOURNAL_GET_JOURNALS_FAILURE = 'FOOD_JOURNAL_GET_JOURNALS_FAILURE';
export const FOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR = 'FOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR';
export const FOOD_JOURNAL_SET_FILTERED_BEGIN = 'FOOD_JOURNAL_SET_FILTERED_BEGIN';
export const FOOD_JOURNAL_SET_FILTERED_SUCCESS = 'FOOD_JOURNAL_SET_FILTERED_SUCCESS';
export const FOOD_JOURNAL_SET_FILTERED_FAILURE = 'FOOD_JOURNAL_SET_FILTERED_FAILURE';
export const FOOD_JOURNAL_SET_FILTERED_DISMISS_ERROR = 'FOOD_JOURNAL_SET_FILTERED_DISMISS_ERROR';
export const FOOD_JOURNAL_GET_JOURNAL_COMMENTS_BEGIN = 'FOOD_JOURNAL_GET_JOURNAL_COMMENTS_BEGIN';
export const FOOD_JOURNAL_GET_JOURNAL_COMMENTS_SUCCESS =
  'FOOD_JOURNAL_GET_JOURNAL_COMMENTS_SUCCESS';
export const FOOD_JOURNAL_GET_JOURNAL_COMMENTS_FAILURE =
  'FOOD_JOURNAL_GET_JOURNAL_COMMENTS_FAILURE';
export const FOOD_JOURNAL_GET_JOURNAL_COMMENTS_DISMISS_ERROR =
  'FOOD_JOURNAL_GET_JOURNAL_COMMENTS_DISMISS_ERROR';
export const FOOD_JOURNAL_ADD_JOURNAL_COMMENT_BEGIN = 'FOOD_JOURNAL_ADD_JOURNAL_COMMENT_BEGIN';
export const FOOD_JOURNAL_ADD_JOURNAL_COMMENT_SUCCESS = 'FOOD_JOURNAL_ADD_JOURNAL_COMMENT_SUCCESS';
export const FOOD_JOURNAL_ADD_JOURNAL_COMMENT_FAILURE = 'FOOD_JOURNAL_ADD_JOURNAL_COMMENT_FAILURE';
export const FOOD_JOURNAL_ADD_JOURNAL_COMMENT_DISMISS_ERROR =
  'FOOD_JOURNAL_ADD_JOURNAL_COMMENT_DISMISS_ERROR';
export const FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_BEGIN =
  'FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_BEGIN';
export const FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_SUCCESS =
  'FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_SUCCESS';
export const FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_FAILURE =
  'FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_FAILURE';
export const FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_DISMISS_ERROR =
  'FOOD_JOURNAL_DELETE_JOURNAL_COMMENT_DISMISS_ERROR';
export const FOOD_JOURNAL_CLEAR_JOURNAL_COMMENTS = 'FOOD_JOURNAL_CLEAR_JOURNAL_COMMENTS';
export const FOOD_JOURNAL_GET_JOURNAL_BEGIN = 'FOOD_JOURNAL_GET_JOURNAL_BEGIN';
export const FOOD_JOURNAL_GET_JOURNAL_SUCCESS = 'FOOD_JOURNAL_GET_JOURNAL_SUCCESS';
export const FOOD_JOURNAL_GET_JOURNAL_FAILURE = 'FOOD_JOURNAL_GET_JOURNAL_FAILURE';
export const FOOD_JOURNAL_GET_JOURNAL_DISMISS_ERROR = 'FOOD_JOURNAL_GET_JOURNAL_DISMISS_ERROR';
export const FOOD_JOURNAL_SET_READ_STATUS_BEGIN = 'FOOD_JOURNAL_SET_READ_STATUS_BEGIN';
export const FOOD_JOURNAL_SET_READ_STATUS_SUCCESS = 'FOOD_JOURNAL_SET_READ_STATUS_SUCCESS';
export const FOOD_JOURNAL_SET_READ_STATUS_FAILURE = 'FOOD_JOURNAL_SET_READ_STATUS_FAILURE';
export const FOOD_JOURNAL_SET_READ_STATUS_DISMISS_ERROR =
  'FOOD_JOURNAL_SET_READ_STATUS_DISMISS_ERROR';
export const FOOD_JOURNAL_SET_JOURNAL_REVIEW_BEGIN = 'FOOD_JOURNAL_SET_JOURNAL_REVIEW_BEGIN';
export const FOOD_JOURNAL_SET_JOURNAL_REVIEW_SUCCESS = 'FOOD_JOURNAL_SET_JOURNAL_REVIEW_SUCCESS';
export const FOOD_JOURNAL_SET_JOURNAL_REVIEW_FAILURE = 'FOOD_JOURNAL_SET_JOURNAL_REVIEW_FAILURE';
export const FOOD_JOURNAL_SET_JOURNAL_REVIEW_DISMISS_ERROR =
  'FOOD_JOURNAL_SET_JOURNAL_REVIEW_DISMISS_ERROR';
export const FOOD_JOURNAL_GET_QUICK_REPLIES_BEGIN = 'FOOD_JOURNAL_GET_QUICK_REPLIES_BEGIN';
export const FOOD_JOURNAL_GET_QUICK_REPLIES_SUCCESS = 'FOOD_JOURNAL_GET_QUICK_REPLIES_SUCCESS';
export const FOOD_JOURNAL_GET_QUICK_REPLIES_FAILURE = 'FOOD_JOURNAL_GET_QUICK_REPLIES_FAILURE';
export const FOOD_JOURNAL_GET_QUICK_REPLIES_DISMISS_ERROR =
  'FOOD_JOURNAL_GET_QUICK_REPLIES_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/constants.js